import { render, staticRenderFns } from "./SelectFieldtype.vue?vue&type=template&id=cb0a87f0&"
import script from "./SelectFieldtype.vue?vue&type=script&lang=js&"
export * from "./SelectFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports